import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/common/base/base.service';
import { FormHistoryServicesHelper } from '../../form-history-services/form-history-services-helper';
import { LogForm } from '../../form-history-services/form-history.service';
import { IFormHistoryService } from '../../form-history-services/i-form-history-service';
import { EB2 } from 'src/app/components/eb/eb';
import { EbService } from 'src/app/components/eb/eb.service';
import { Form } from 'src/app/services/forms/form';
import { Tag } from 'src/app/common/enumerations/enumerations';

@Injectable({
  providedIn: 'root'
})
export class FormHistoryEbService extends BaseService<any, number> implements IFormHistoryService {

  amendmentSectionNumbers = [12, 13];
  helper = FormHistoryServicesHelper;

  constructor(
    protected override injector: Injector,
  ) {
    super(injector, '');
  }

  async processForm(form: any, logForm: LogForm) {

    form.createdByName = this.users?.find(u => u.id === form.createdBy)?.name;
    form.requesterName = this.users?.find(u => u.id === form.requesterId)?.name;

    logForm.updates = this.processUpdates(logForm, form);
    logForm.originalBody = form;
    return logForm;
  }

  /**
   * Parses history snapshots and assigns each update its previous and amended bodies.
   * @param logForm Workflow history containing serialized update snapshots.
   * @param form Form body used as the history baseline.
   */
  processUpdates(logForm: LogForm, form: Form) {
    // ---- Amendments list ----
    const amendmentsSet = new Set<number>(this.helper.getAmendmentList(logForm.signatures ?? []));

    // ---- Updates ----
    const updates = logForm?.updates ?? [];

    updates?.forEach(update => {
      // Parse old body
      if (update.prevBodyJson) {
        const prev = this.helper.createBody(update.prevBodyJson, this.users);
        const current = this.helper.createBody(update.currentBodyJson ?? '', this.users);
        update.prevBody = prev;
        update.currentBody = current;
        if (update.amendmentId && amendmentsSet)
          update.header = this.helper.getLogHeadText(update.amendmentId, amendmentsSet);
      }
    });

    return updates;
  }
}
